<template>
  <div class="d-flex align-center text-grey-700">
    <img src="@/assets/img/icons/pdf.svg"
         class="mr-2"
         alt="PDF icon"
         width="17"
    />
    {{ envelopeTemplateName }}
  </div>
</template>

<script>
export default {
  name: 'Name',
  props: {
    envelopeTemplateName: {
      type: String,
      required: true,
    },
  },
}
</script>
